'use client';

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer,  } from 'recharts';

// Backend integration point: GET /api/ehs/metrics/incidents-by-department
const deptData = [
  { dept: 'Chemical Proc.', incidents: 11, nearMiss: 8, color: '#ef4444' },
  { dept: 'Maintenance', incidents: 9, nearMiss: 12, color: '#f97316' },
  { dept: 'Operations', incidents: 7, nearMiss: 15, color: '#f59e0b' },
  { dept: 'Construction', incidents: 6, nearMiss: 5, color: '#eab308' },
  { dept: 'Electrical', incidents: 4, nearMiss: 7, color: '#84cc16' },
  { dept: 'Logistics', incidents: 3, nearMiss: 9, color: '#22c55e' },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-lg px-4 py-3 shadow-xl text-xs">
      <p className="font-600 text-[hsl(var(--foreground))] mb-2">{label}</p>
      {payload.map((entry: any) => (
        <div key={`ttd-${entry.dataKey}`} className="flex items-center gap-2 mb-1">
          <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: entry.color }} />
          <span className="text-[hsl(var(--muted-foreground))]">{entry.name}:</span>
          <span className="font-600 tabular-nums text-[hsl(var(--foreground))]">{entry.value}</span>
        </div>
      ))}
    </div>
  );
};

export default function DepartmentIncidentChart() {
  return (
    <div className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-xl p-5 h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-sm font-600 text-[hsl(var(--foreground))]">Incidents by Department</h3>
          <p className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">
            Q2 2026 · Recordable incidents vs near-misses
          </p>
        </div>
        <div className="flex items-center gap-4 text-xs text-[hsl(var(--muted-foreground))]">
          <span className="flex items-center gap-1.5">
            <span className="w-2.5 h-2.5 rounded-sm bg-[hsl(var(--primary))]" />
            Incidents
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-2.5 h-2.5 rounded-sm bg-blue-400/50" />
            Near-Miss
          </span>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={240}>
        <BarChart
          data={deptData}
          margin={{ top: 4, right: 8, left: -12, bottom: 0 }}
          barCategoryGap="30%"
          barGap={2}
        >
          <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" strokeOpacity={0.5} vertical={false} />
          <XAxis
            dataKey="dept"
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="incidents" name="Incidents" radius={[3, 3, 0, 0]} maxBarSize={24}>
            {deptData.map((entry) => (
              <Cell key={`cell-dept-${entry.dept}`} fill={entry.color} fillOpacity={0.9} />
            ))}
          </Bar>
          <Bar dataKey="nearMiss" name="Near-Miss" fill="#60a5fa" fillOpacity={0.45} radius={[3, 3, 0, 0]} maxBarSize={24} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}